module.exports = __webpack_public_path__ + "staticVue/img/about_photo01.8c05c029.jpg";